import React from 'react'
import { Alert, Link } from '@paypalcorp/pp-react'
import '../../styles/components/banner/_banner.scss'
import { TopNavBannerSandbox } from '../common/top-nav/top-nav-banner-sandbox'
import { useApplicationContext } from '../../context/ApplicationContext'

function BannerModule({ bannerInfo, offset }) {
  const { isLinkActive, text, url, urlText, isActive } = bannerInfo

  const { isBannerHidden, setIsBannerHidden } = useApplicationContext()

  return (
    <>
      <div className="dev_dash__top-nav-banner" style={{ top: `${offset}px` }}>
        {!isBannerHidden && isActive === 'on' && (
          <Alert
            type="info"
            style={{ maxWidth: '100%', borderRadius: 0 }}
            closeButton={{
              'aria-label': 'dismiss alert',
              onClick: () => {
                window.sessionStorage.setItem('hideAlert', true)
                setIsBannerHidden(true)
              },
            }}
          >
            {text}{' '}
            {isLinkActive === 'on' && (
              <Link target="_blank" href={url} rel="noreferrer">
                {urlText}
              </Link>
            )}
          </Alert>
        )}
        <Alert type="warning" className="mobile-banner-warning">
          <strong>Our dashboard works best on desktop</strong>
          <br />
          If something isn’t working on mobile, try switching to a desktop
          computer.
        </Alert>

        <TopNavBannerSandbox label={'top-nav.banner.sandbox'} />
      </div>
    </>
  )
}

export default BannerModule
